import * as toolbox from 'components/common/toolbox';
import React from 'react';
import { confirmDelete } from 'components/common/toolbox';

const LineItemsTotals = (props) => {

    return (

        <div className="col-12 d-flex justify-content-end">
            <table className="subtotal">
                <tbody>
                    <tr>
                        <td align="right">SUBTOTAL: </td>
                        <td width="5"></td>
                        <td align="right">{toolbox.formatNumber(props.totals?.grossTotal, 2, true)}</td>
                        <td align="right" style={{width: '40px'}}></td>
                    </tr>
                    { !!parseFloat(props.totals?.discountFlatrate) &&
                        <tr>
                            <td align="right">DISCOUNT: </td>
                            <td width="5"></td>
                            <td align="right" className="text-danger">- {toolbox.formatNumber(props.totals?.discountFlatrate, 2, true)}</td>
                            <td align="right" style={{width: '40px'}}>
                                <div className="" role="button" title="Remove Discount" onClick={() => {confirmDelete('Discount', props.removeDiscount.bind(this, 'discount-flatrate'), { soft: true })}}>
                                    <i class="fa-solid fa-trash-xmark fa-lg text-muted"></i>
                                </div>
                            </td>
                        </tr>
                    }
                    { !!parseFloat(props.totals?.discountPercent) &&
                        <tr>
                            <td align="right">DISCOUNT ({toolbox.formatNumber(props.totals?.discountRate, 2, false)}%): </td>
                            <td width="5"></td>
                            <td align="right" className="text-danger">- {toolbox.formatNumber(props.totals?.discountPercent, 2, true)}</td>
                            <td align="right" style={{width: '40px'}}>
                                <div className="" role="button" title="Remove Discount" onClick={() => {confirmDelete('Discount', props.removeDiscount.bind(this, 'discount-percent'), { soft: true })}}>
                                    <i class="fa-solid fa-trash-xmark fa-lg text-muted"></i>
                                </div>
                            </td>
                        </tr>
                    }
                    { !!parseFloat(props.totals?.depositApplied) &&
                        <tr>
                            <td align="right">DEPOSIT APPLIED: </td>
                            <td width="5"></td>
                            <td align="right" className="text-danger">- {toolbox.formatNumber(props.totals?.depositApplied, 2, true)}</td>
                            <td align="right" style={{width: '40px'}}></td>
                        </tr>
                    }
                    <tr>
                        <td align="right">TAX ({(props.totals?.taxRate ?? 0)}%):</td>
                        <td width="5"></td>
                        <td align="right">{toolbox.formatNumber(props.totals?.taxTotal, 2, true)}</td>
                        <td align="right" style={{width: '40px'}}></td>
                    </tr>
                    <tr><td colSpan={ 99 }><div className="mt-2"></div></td></tr>
                    <tr>
                        <td align="right" className="font-weight-bold">GRAND TOTAL: </td>
                        <td width="5"></td>
                        <td align="right">{ toolbox.formatNumber(props.totals?.grandTotal, 2, true) }</td>
                        <td align="right" style={{width: '40px'}}></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default LineItemsTotals;